{{#if settings }}
  <ul>
    {{#each settings }}
      <li class="group-settings-option">

        <label class="tool-label">
          {{ humanize group }}
        </label>

        {{sp_select_tag "" class="tool-field" dataSettingsGroup=group choices=items selected=value searchable=searchable}}

        <div class="customized shared-component-options">
          <a href="" class="setting-reset">
            {{{ icon "close-alt-color" }}} Remove Override
          </a>
        </div>

      </li>
    </br>
    {{/each}}
  </ul>
{{/if}}
